<template>
  <search-layout>
    <template v-slot:contents>
      <v-col cols="12" class="d-flex flex-wrap justify-space-between">
        <v-col cols="12" xl="2" md="4" class="d-flex align-center">
          <v-col cols="4" class="pa-0">기준년월</v-col>
            <v-text-field
                v-model="baseYm"
                outlined
                hide-details
                dense
                background-color="white"
            />
            <v-btn class="button" outlined @click="search">조회</v-btn>
        </v-col>

        <v-col cols="12" xl="10" md="8" class="d-flex justify-end">
          <v-btn class="button pa-5 mr-2" outlined @click="showExcelUpload('info')">
            지급명세 업로드
          </v-btn>
          <v-btn class="button pa-5" outlined @click="showExcelUpload('detail')">
            거래내역 업로드
          </v-btn>
        </v-col>
      </v-col>
      <payment-excel-upload-popup
        :is-show="isShowExcelUpload"
        :upload-type="uploadType"
        @close="isShowExcelUpload = false"
      />
    </template>
  </search-layout>
</template>
<script>
import SearchLayout from "@/common/layout/SearchLayout.vue";
import DateMixin from "@/mixin/DateMixin";
import {axiosInstance} from "@/util/AxiosModule";
import PaymentExcelUploadPopup from "@/pages/Payment/components/PaymentManage/popup/PaymnetExcelUploadPopup.vue";

export default {
  name: "PaymentManageSearchBar",
  components: {PaymentExcelUploadPopup, SearchLayout},
  mixins: [DateMixin],
  data() {
    return {
      baseYm: "",
      uploadType: "",
      isShowExcelUpload: false
    }
  },
  mounted() {
    this.getBaseYm();
  },
  methods: {
    async getBaseYm() {
      try {
        const response = await axiosInstance.get("/private/statement/lastBaseYM");

        if (response.data === undefined || response.data === null) {
          this.baseYm = "";
        } else {
          this.baseYm = String(response.data).trim();
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    search() {
      const params = {
        baseYm: this.baseYm
      };
      this.$emit("search", params);
    },
    showExcelUpload(type) {
      this.uploadType = type;
      this.isShowExcelUpload = true;
    },
  }
}
</script>